// extracted by mini-css-extract-plugin
export var hideEditor = "_l4-2";
export var infoIcon = "_l4-3";
export var label = "_l4-1";
export var labelContainer = "_l4-0";
export var readonlyText = "_l4-4";